import React from 'react';
import { UIView } from '@uirouter/react';
import { connect } from 'react-redux';
import { extraOperations } from 'insured-ui-state-mgmt/dist/ducks/extra';

class ModalHandlerScreen extends React.Component {
  constructor(props) {
    super(props);
    console.log(props);
  }

  render() {
    return (
      <div>
        <button
          id="showSignupModal"
          style={{ display: 'none' }}
          onClick={() => {
            this.props.showSecurityPortlet();
          }}
        />
        <UIView />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  extra: state.extra,
});

const mapDispatchToProps = {
  showSecurityPortlet: extraOperations.showSecurityPortlet,
  hideSecurityPortlet: extraOperations.hideSecurityPortlet,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalHandlerScreen);
